import React from 'react';
import { Link } from 'react-router-dom';
import { ListGroup } from 'reactstrap';

import WarfareModal from '../PracticeExam/WarfareModal';
import SwitchToPaidModal from '../SwitchToPaid/SwitchToPaidModal';
import AudioPlayer from './Audio/AudioPlayer';
import ListGroupItem from './ListGroupItem';
import { UpgradeSubscriptionForAudiosModal } from './UpgradeSubscriptionForAudiosModal';

class StudyList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenSwitchToPaid: false,
      isOpenWarfare: false,
      isOpenAudioPlayer: false,
      isOpenUpgradeSubscriptionForAudios: false,
      audioPlaylist: null,
      chapterNameForAudioPlaylist: null,
      chaptersWithPlaylists: [],
    };
  }

  componentDidMount() {
    if (this.props.setIsStudyingSubmittedQuestions) {
      this.props.setIsStudyingSubmittedQuestions(false);
    }
    if (this.props.setIsStudyingFavoriteQuestions) {
      this.props.setIsStudyingFavoriteQuestions(false);
    }
    if (this.props.setIsStudyingMySubmittedQuestions) {
      this.props.setIsStudyingMySubmittedQuestions(false);
    }
    if (this.props.setIsStudyingMyFavoriteQuestions) {
      this.props.setIsStudyingMyFavoriteQuestions(false);
    }

    this.setState({
      chaptersWithPlaylists: this.getChaptersWithPlaylists(),
    });

    // Only fetch if we have items and aren't already fetched/fetching
    if (
      this.props.items?.references &&
      !this.props.audioPlaylistsProgressFetched &&
      !this.props.audioPlaylistsProgressFetching
    ) {
      this.loadAllAudioProgress();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.audioPlaylist !== prevProps.audioPlaylist) {
      this.setState({ audioPlaylist: this.props.audioPlaylist });
    }

    if (prevProps.items !== this.props.items && this.props.items?.references) {
      this.setState({ chaptersWithPlaylists: this.getChaptersWithPlaylists() });
      if (
        !this.props.audioPlaylistsProgressFetched &&
        !this.props.audioPlaylistsProgressFetching
      ) {
        this.loadAllAudioProgress();
      }
    }
  }

  getChaptersWithPlaylists = () => {
    if (!this.props.items?.references) return [];

    return this.props.items.references
      .map((r) => r.chapters)
      .flat()
      .filter(
        (c) => (c.hasPlaylist || c.hasAudioSummary) && !c.disabledChapter,
      );
  };

  // method override for immediate update
  updateDisabledChapter = (chapterId, userId) => {
    this.props.updateDisabledChapter(chapterId, userId);

    // Find the chapter and toggle (optimistic)
    const allChapters = this.props.items.references.flatMap((r) => r.chapters);

    const chapter = allChapters.find((c) => c.id === chapterId);
    if (chapter) {
      // Optimistic toggle: Reverse the current state
      chapter.disabledChapter = !chapter.disabledChapter;
    }
    // Recalculate using getAvailableChapters (which already filters by disabledChapter)
    this.setState({
      chaptersWithPlaylists: this.getChaptersWithPlaylists(),
    });
  };

  loadAllAudioProgress = () => {
    if (!this.props.items?.references) return;

    const allChapterIds = this.props.items.references
      .flatMap((reference) => reference.chapters || [])
      .filter((chapter) => chapter.hasPlaylist || chapter.hasAudioSummary)
      .map((chapter) => chapter.id);

    if (allChapterIds.length > 0) {
      this.props.getAudioPlaylistsProgress(allChapterIds);
    }
  };

  openSwitchToPaid = () => {
    this.setState({ isOpenSwitchToPaid: true });
  };

  closeSwitchToPaid = () => {
    this.setState({
      isOpenSwitchToPaid: false,
      switchToPaidModalIsForAudio: false,
    });
  };

  setSwitchToPaidModalIsForAudio = (isForAudio) => {
    this.setState({ switchToPaidModalIsForAudio: isForAudio });
  };

  openWarfareModal = () => {
    this.setState({ isOpenWarfare: true });
  };

  openAudioPlayer = (chapterId, chapterName) => {
    this.props.getAudioPlaylist(chapterId);
    this.setState({
      isOpenAudioPlayer: true,
      chapterNameForAudioPlaylist: chapterName,
    });
  };

  getPreviousChapterWithPlaylist = (currentChapterId) => {
    const currentChapterIdx = this.state.chaptersWithPlaylists.findIndex(
      (c) => c.id === currentChapterId,
    );
    return this.state.chaptersWithPlaylists
      .slice(0, currentChapterIdx)
      .reverse()[0];
  };

  getNextChapterWithPlaylist = (currentChapterId) => {
    const currentChapterIdx = this.state.chaptersWithPlaylists.findIndex(
      (c) => c.id === currentChapterId,
    );
    return this.state.chaptersWithPlaylists.slice(
      currentChapterIdx + 1,
      this.state.chaptersWithPlaylists.length,
    )[0];
  };

  isFirstPlaylist = (currentChapterId) =>
    !this.getPreviousChapterWithPlaylist(currentChapterId);

  isLastPlaylist = (currentChapterId) =>
    !this.getNextChapterWithPlaylist(currentChapterId);

  getPreviousPlaylist = (currentChapterId) => {
    const previousChapter =
      this.getPreviousChapterWithPlaylist(currentChapterId);
    if (previousChapter) {
      this.props.getAudioPlaylist(previousChapter.id);
      this.setState({
        chapterNameForAudioPlaylist: previousChapter.name,
      });
    }
  };

  getNextPlaylist = (currentChapterId) => {
    const nextChapter = this.getNextChapterWithPlaylist(currentChapterId);
    if (nextChapter) {
      this.props.getAudioPlaylist(nextChapter.id);
      this.setState({
        chapterNameForAudioPlaylist: nextChapter.name,
      });
    }
  };

  render() {
    const playlistIterator = this.state.audioPlaylist
      ? {
          isFirst: () => this.isFirstPlaylist(this.state.audioPlaylist.chapter),
          getPrevious: () =>
            this.getPreviousPlaylist(this.state.audioPlaylist.chapter),
          current: {
            ...this.state.audioPlaylist,
            title: this.state.chapterNameForAudioPlaylist,
          },
          getNext: () => this.getNextPlaylist(this.state.audioPlaylist.chapter),
          isLast: () => this.isLastPlaylist(this.state.audioPlaylist.chapter),
        }
      : null;

    const noReferences = this.props.items?.references?.length === 0;

    return (
      <>
        {!noReferences ? (
          <div data-test="study-list">
            {Array.isArray(this.props.items?.references) &&
              this.props.items.references.length > 0 &&
              this.props.items.references.map((reference) => (
                <ListGroup key={reference.id}>
                  <ListGroupItem
                    user={this.props.user}
                    userSubscription={this.props.userSubscription}
                    nextUpQualIndex={this.props.nextUpQualIndex}
                    setQuestionNotification={this.props.setQuestionNotification}
                    name={reference.name}
                    studyProgramId={this.props.items.studyProgramId}
                    description={reference.description}
                    fullPDF={reference.pdfUrl}
                    chapters={reference.chapters}
                    actAsParent={reference.actAsParent}
                    new={reference.new}
                    review={reference.review}
                    learning={reference.learning}
                    location={this.props.location}
                    reviewWhen={reference.reviewWhen}
                    reviewWhenIndicator={reference.reviewWhenIndicator}
                    setChapterId={this.props.setChapterId}
                    getPdfByReference={this.props.getPdfByReference}
                    openSwitchToPaid={() => this.openSwitchToPaid()}
                    openWarfareModal={() => this.openWarfareModal()}
                    weNeedThisPublication={reference.weNeedThisPublication}
                    updateDisabledChapter={this.updateDisabledChapter}
                    startAudioPlaylist={(chapterId, chapterName) => {
                      this.openAudioPlayer(chapterId, chapterName);
                    }}
                    setSwitchToPaidModalIsForAudio={
                      this.setSwitchToPaidModalIsForAudio
                    }
                    openUpgradeSubscriptionForAudiosModal={() => {
                      this.setState({
                        isOpenUpgradeSubscriptionForAudios: true,
                      });
                    }}
                    audioPlaylistsProgress={this.props.audioPlaylistsProgress}
                    updateAudioPlaylistProgress={
                      this.props.updateAudioPlaylistProgress
                    }
                  />
                </ListGroup>
              ))}
            <SwitchToPaidModal
              user={this.props.user}
              userSubscription={this.props.userSubscription}
              isOpen={this.state.isOpenSwitchToPaid}
              onCancel={() => this.closeSwitchToPaid()}
              activateSubscription={() => this.props.activateSubscription()}
              subscriptionActivationSucces={
                this.props.subscriptionActivationSucces
              }
              subssrccriptionActivationWaiting={
                this.props.subscriptionActivationWaiting
              }
              subscriptionActivationMessage={
                this.props.subscriptionActivationMessage
              }
              isForAudio={this.state.switchToPaidModalIsForAudio}
            />
            <WarfareModal
              open={this.state.isOpenWarfare}
              closeModal={() => this.setState({ isOpenWarfare: false })}
            />
            {this.state.isOpenAudioPlayer && (
              <AudioPlayer
                playlistIterator={playlistIterator}
                open={this.state.isOpenAudioPlayer}
                close={() => this.setState({ isOpenAudioPlayer: false })}
                updateAudioPlaylistProgress={
                  this.props.updateAudioPlaylistProgress
                }
                audioPlaylistsProgress={this.props.audioPlaylistsProgress}
              />
            )}
            <UpgradeSubscriptionForAudiosModal
              isOpen={this.state.isOpenUpgradeSubscriptionForAudios}
              toggle={() =>
                this.setState({
                  isOpenUpgradeSubscriptionForAudios:
                    !this.state.isOpenUpgradeSubscriptionForAudios,
                })
              }
            />
          </div>
        ) : (
          <div className="empty-state">
            <div className="empty-state__card">
              <header className="empty-state__header">
                <h2 className="empty-state__title">
                  This AFSC has too little material to offer as a service.
                </h2>
                <p className="empty-state__subtitle">
                  We made the decision to close this AFSC study plan down until
                  we can offer more material.
                </p>
                <Link
                  to="/app/account-settings"
                  className="text-default btn btn--link"
                >
                  <p>Change AFSC exam</p>
                </Link>
              </header>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default StudyList;
